import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { accountService } from "../services/account.service";
import { AccountRequest } from "../domain/account.interface";

export const useGetAccounts = () => {
	return useQuery({
		queryKey: ["accounts"],
		queryFn: () => accountService.getAccounts(),
	});
};

export const useGetAccount = (accountId: string) => {
	return useQuery({
		queryKey: ["account", accountId],
		queryFn: () => accountService.getAccount(accountId),
		enabled: !!accountId,
	});
};

export const useCreateAccount = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (accountData: AccountRequest) =>
			accountService.createAccount(accountData),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["accounts"] });
		},
	});
};

export const useUpdateAccount = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: ({
			accountId,
			accountData,
		}: {
			accountId: string;
			accountData: Partial<AccountRequest>;
		}) => accountService.updateAccount(accountId, accountData),
		onSuccess: (_data, variables) => {
			queryClient.invalidateQueries({ queryKey: ["accounts"] });
			queryClient.invalidateQueries({
				queryKey: ["account", variables.accountId],
			});
		},
	});
};
